import { render, staticRenderFns } from "./ProfileRedirectPage.vue?vue&type=template&id=3e675ec6&"
import script from "./ProfileRedirectPage.vue?vue&type=script&lang=ts&"
export * from "./ProfileRedirectPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e675ec6')) {
      api.createRecord('3e675ec6', component.options)
    } else {
      api.reload('3e675ec6', component.options)
    }
    module.hot.accept("./ProfileRedirectPage.vue?vue&type=template&id=3e675ec6&", function () {
      api.rerender('3e675ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/ProfileRedirectPage.vue"
export default component.exports